<template>
    <div class="ordercart">
        <div class="cartcancel">
            <span onclick="hideCartList()">X</span>
        </div>
        <div class="order-pro-list my-fancy-scrollbar">
            <new-cart-list :cart-list="myCartList"></new-cart-list>
        </div>
        <div class="order-pro-total">
            <div style="width: 100%; white-space: nowrap; overflow: hidden">
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        padding: 0px;
                    "
                >
                    <div>商品總計</div>
                    <div>{{ cartTotalAmount | currency }}</div>
                </div>
                <!--
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        padding: 8px 0px 0px;
                    "
                >
                    <div>折扣</div>
                    <div>-NT$34</div>
                </div>
                -->
                <!--
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        padding: 8px 0px 0px;
                    "
                >
                    <div>運費</div>
                    <div>未選擇</div>
                </div>
                -->
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        padding: 16px 0px 0px;
                        font-size: 18px;
                    "
                >
                    <div>訂單總金額</div>
                    <div style="font-size: 20px; font-weight: bold">
                        {{ billTotalAmount | currency }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CartListBase from "../Carts/CartListBase.vue";

    export default {
        extends: CartListBase,
        data() {
            return {
                logisticsAmount: 0,
                couponAmount: 0,
            };
        },
        computed: {
            billTotalAmount() {
                return (
                    this.cartTotalAmount + this.logisticsAmount - this.couponAmount
                );
            },
            cartTotalAmount: CartListBase.computed.totalAmount,
        },
    };
</script>
<style lang="scss">
    .order-cart {
        min-height: 100%;

        .order-pro-total {
            margin-top: auto;
        }
    }

    .ordercart {
        position: fixed;
        top: 0px;
        right: 0px;
        max-width: 560px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-left: 20px solid rgba(234, 205, 212, 0.15);

        @media (max-width: 767px) {
            position: initial;
            border-left: 0px !important;
        }
    }
</style>